<template>
<div id="">
  <v-container fluid class="pt-0">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">

          <v-card-title class="secondary white--text">
            {{account.name}}

            <v-spacer></v-spacer>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
            <v-btn icon dark @click="$router.go(-1)" exact>
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary"></v-progress-linear>
          </v-card-title>

          <v-container class="">
            <v-row class="text-center text-md-left" justify="center">
              <v-col cols="12" sm="6" lg="4" xl="3" id="section-1">
                <profile-video title="My Interests" :video="section_1" :upload="upload_1" @reject="rejectVideo" @update="updateVideo" @thumbnail="uploadThumbnail" @upload="uploadVideo({file: $event,section: 1})"></profile-video>
              </v-col>
              <v-col cols="12" sm="6" lg="4" xl="3" id="section-2">
                <profile-video title="My Work Experience" :video="section_2" :upload="upload_2" @reject="rejectVideo" @update="updateVideo" @thumbnail="uploadThumbnail" @upload="uploadVideo({file: $event,section: 2})"></profile-video>
              </v-col>
              <v-col cols="12" sm="6" lg="4" xl="3" id="section-3">
                <profile-video title="My Thank You Video" :video="section_3" :upload="upload_3" @reject="rejectVideo" @update="updateVideo" @thumbnail="uploadThumbnail" @upload="uploadVideo({file: $event,section: 3})"></profile-video>
              </v-col>
            </v-row>


            <v-row align="center" justify="center" v-if="publishedProjects.length">
              <v-col cols="12" xl="9">
                <v-card tile>
                  <v-card-actions class="secondary white--text">
                    <v-col cols="9">
                      <h3>My Published Work</h3>
                    </v-col>
                  </v-card-actions>
                </v-card>
                <v-container>
                  <v-row align="center" justify="start">
                    <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-for="(project,i) in publishedProjects" :key="i">
                      <project-tile :project="project"></project-tile>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>


            <v-row align="center" justify="center" class="mt-4 mb-4" v-if="account.profile_links.length || account.resume">
              <v-col cols="12" xl="9">
                <v-card>
                  <v-card-actions class="secondary white--text">
                    <v-col cols="6">
                      <h3>My Links</h3>
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <v-chip dark v-if="account.resume" color="blue">
                        <a target="_blank" class="nolink white--text" :href="account.resume">Resume</a>
                      </v-chip>
                    </v-col>
                  </v-card-actions>

                  <profile-links :links="account.profile_links"></profile-links>

                </v-card>
              </v-col>
            </v-row>

            <v-row align="center" justify="center" class="mt-4 mb-4" v-if="account.projects.length">
              <v-col cols="12" xl="9">
                <user-rank :account="account"></user-rank>
              </v-col>
            </v-row>
            <v-row align="center" justify="center" class="mt-4 mb-4" v-if="account.projects.length">
              <v-col cols="12" xl="9">
                <user-progress :account="account"></user-progress>
              </v-col>
            </v-row>


          </v-container>


        </v-card>
      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import profileVideo from "./profile-video"
import projectTile from "./project-tile"
import profileLinks from "./profile-links"
import userProgress from "./progress"
import userRank from "./rank"

import Axios from "axios"

export default {
  name: "",
  components: {
    userProgress,
    userRank,
    profileVideo,
    projectTile,
    profileLinks
  },
  data: () => ({
    account: {
      profile_videos: [],
      projects: [],
      profile_links: []
    },
    uploads: [],
    loading: false
  }),
  created() {
    this.load()
  },
  computed: {
    upload_1() {
      return this.uploads.find(u => {
        return u.section === 1
      })
    },
    upload_2() {
      return this.uploads.find(u => {
        return u.section === 2
      })
    },
    upload_3() {
      return this.uploads.find(u => {
        return u.section === 3
      })
    },
    section_1() {
      return this.account.profile_videos.find(v => {
        return v.section === 1
      })
    },
    section_2() {
      return this.account.profile_videos.find(v => {
        return v.section === 2
      })
    },
    section_3() {
      return this.account.profile_videos.find(v => {
        return v.section === 3
      })
    },
    publishedProjects() {
      return this.account.projects.filter(p => {
        return p.status === 11 || p.status == 12
      })
    }
  },
  methods: {
    async load() {
      this.loading = true
      this.account = await this.$api(`/account/admin/accounts/${this.$route.params.id}`)
      this.loading = false
    },
    async rejectVideo(options) {
      if (!confirm("Sure you want to reject this profile video ? ")) {
        return;
      }
      this.loading = true;
      await this.$api({
        method: "GET",
        url: `/account/admin/profile-videos/${options.video.id}/reject`
      })
      this.load()
    },
    async updateVideo(options) {
      this.loading = true;
      await this.$api({
        method: "POST",
        url: `/account/admin/profile-videos/${options.video.id}`,
        data: options.data
      })
      this.load()
    },
    async uploadThumbnail(options) {
      //options.video.
      //options.file.
      let upload = {
        section: options.section,
        file: options.file,
        progress: 0
      }
      this.uploads.push(upload)

      let upload_url = await this.$api({
        method: "POST",
        url: `/account/upload-url`,
        data: {
          file: {
            name: options.file.name,
            size: options.file.size,
            type: options.file.type
          },
          key: `edited-profile-videos/${this.account.id}/${options.section}`
        }
      })
      var upload_options = {
        headers: {
          'Content-Type': options.file.type,
          'x-amz-acl': 'public-read'
        },
        'Metadata': {
          'Content-Disposition': 'attachment'
        },
        onUploadProgress: function(progressEvent) {
          upload.progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        }.bind(this)
      };
      await Axios.put(upload_url, options.file, upload_options)

      await this.updateVideo({
        video: options.video,
        data: {
          thumbnail: upload_url.split("?")[0]
        }
      })

      this.deleteUpload(upload)

    },
    async uploadVideo(options) {
      let upload = {
        section: options.section,
        file: options.file,
        progress: 0
      }
      this.uploads.push(upload)

      let upload_url = await this.$api({
        method: "POST",
        url: `/account/upload-url`,
        data: {
          file: {
            name: options.file.name,
            size: options.file.size,
            type: options.file.type
          },
          key: `edited-profile-videos/${this.account.id}/${options.section}`
        }
      })
      var upload_options = {
        headers: {
          'Content-Type': options.file.type,
          'x-amz-acl': 'public-read'
        },
        'Metadata': {
          'Content-Disposition': 'attachment'
        },
        onUploadProgress: function(progressEvent) {
          upload.progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        }.bind(this)
      };
      await Axios.put(upload_url, options.file, upload_options)

      this.addVideo({
        url: upload_url.split("?")[0],
        file_name: options.file.name,
        file_size: options.file.size,
        section: options.section,
        approved: 1,
        visible: 1,
        account_id: this.account.id
      })

      this.deleteUpload(upload)
    },
    async addVideo(video) {
      let added_video = await this.$api({
        method: "POST",
        url: `/account/admin/profile-videos`,
        data: video
      })
      this.account.profile_videos.unshift(added_video)
    },
    deleteUpload(upload) {
      this.uploads = this.uploads.filter(v => {
        return v !== upload
      })
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
